import { RequestPricingComponent } from './../request-pricing/request-pricing.component';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ColfRequestDetail, FHService } from 'npx-family-happy-common';
import { Subject, takeUntil } from 'rxjs';
import { ColfService } from 'src/app/caregiver/colf/colf-service/colf-service.service';

@Component({
  selector: 'app-request-colf-detail-form',
  templateUrl: './request-colf-detail-form.component.html',
  styleUrls: ['./request-colf-detail-form.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RequestPricingComponent]
})
export class RequestColfDetailFormComponent implements OnInit {

  @Input() inputData!: ColfRequestDetail;
  @Input() requestID!: number;
  @Input() provincia!: string;
  @Input() reqService!: FHService;
  @Output() dataUpdated = new EventEmitter<ColfRequestDetail>();

  form = new UntypedFormGroup({
    requestedExp: new UntypedFormGroup({
      requestedExpCluster1: new UntypedFormControl(false),
      requestedExpCluster2: new UntypedFormControl(false),
    }),
    requiredLanguage: new UntypedFormGroup({
      italian: new UntypedFormControl(false),
      english: new UntypedFormControl(false),
      spanish: new UntypedFormControl(false)
    }),
    requestedAge: new UntypedFormGroup({
      requestedAgeCluster1: new UntypedFormControl(false),
      requestedAgeCluster2: new UntypedFormControl(false),
      requestedAgeCluster3: new UntypedFormControl(false)
    }),
    starting: new UntypedFormControl('', Validators.required),
    estimatedLasting: new UntypedFormControl('', Validators.required),
    serviceStart: new UntypedFormControl('', Validators.required),
    serviceDuration: new UntypedFormControl('', Validators.required),
    continuousJob: new UntypedFormControl(false, Validators.required),
    moreThanOne: new UntypedFormControl(false, Validators.required),
    badWorkHours: new UntypedFormControl(false, Validators.required),
    taxisitter: new UntypedFormControl(false),
    license: new UntypedFormControl(false),
    car: new UntypedFormControl(false),
    hoursAmount: new UntypedFormControl(0),
    netHourCost: new UntypedFormControl(0),
    flatCost: new UntypedFormControl(0),
    flatCostTiming: new UntypedFormControl(0),
    packageFlatCost: new UntypedFormControl(0),
    coliving: new UntypedFormControl(false),
    relocation: new UntypedFormControl(false),
    withholdingTax: new UntypedFormControl(false),
    inconvenientLocation: new UntypedFormControl(false),
    days: new UntypedFormGroup({
      sun: new UntypedFormControl(false),
      mon: new UntypedFormControl(false),
      tue: new UntypedFormControl(false),
      wed: new UntypedFormControl(false),
      thu: new UntypedFormControl(false),
      fri: new UntypedFormControl(false),
      sat: new UntypedFormControl(false),
    }),
    hours: new UntypedFormGroup({
      mor: new UntypedFormControl(false),
      aft: new UntypedFormControl(false),
      eve: new UntypedFormControl(false),
    }),
    requestDescription: new UntypedFormControl('', Validators.required),
    cooking: new UntypedFormControl(false),
    gardening: new UntypedFormControl(false),
    groceries: new UntypedFormControl(false),
    helping: new UntypedFormControl(false),
    houseCleaning: new UntypedFormControl(false),
    ironing: new UntypedFormControl(false),
    sewing: new UntypedFormControl(false),
    terraceCleaning: new UntypedFormControl(false),
    washingMachines: new UntypedFormControl(false),
    windowCleaning: new UntypedFormControl(false)
  })

  private unsubscribe = new Subject<void>();

  constructor(private colfService: ColfService) { }

  ngOnInit(): void {
    this.initForm();
    this.form.valueChanges
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((_) => {
        this.pushDataChanges();
      })
  }


  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private initForm() {
    this.form.setValue({
      starting: this.inputData.starting,
      estimatedLasting: this.inputData.estimatedLasting,
      serviceStart: this.inputData.serviceStart,
      serviceDuration: this.inputData.serviceDuration,
      continuousJob: this.inputData.continuousJob,
      moreThanOne: this.inputData.moreThanOne,
      badWorkHours: this.inputData.badWorkHours,
      taxisitter: this.inputData.taxisitter,
      hoursAmount: this.inputData.hoursAmount,
      netHourCost: this.inputData.netHourCost,
      flatCost: this.inputData.flatCost,
      flatCostTiming: this.inputData.flatCostTiming,
      packageFlatCost: this.inputData.packageFlatCost,
      coliving: this.inputData.coliving,
      relocation: this.inputData.relocation,
      withholdingTax: this.inputData.withholdingTax,
      inconvenientLocation: this.inputData.inconvenientLocation,
      requestDescription: this.inputData.requestDescription,
      license: this.inputData.license,
      car: this.inputData.car,
      cooking: this.inputData.cooking,
      gardening: this.inputData.gardening,
      groceries: this.inputData.groceries,
      helping: this.inputData.helping,
      houseCleaning: this.inputData.houseCleaning,
      ironing: this.inputData.ironing,
      sewing: this.inputData.sewing,
      terraceCleaning: this.inputData.terraceCleaning,
      washingMachines: this.inputData.washingMachines,
      windowCleaning: this.inputData.windowCleaning,
      requestedExp: {
        requestedExpCluster1: this.inputData.requestedExp ? this.inputData.requestedExp.includes('Cuccioli') : false,
        requestedExpCluster2: this.inputData.requestedExp ? this.inputData.requestedExp.includes('Adulti') : false,
      },
      requestedAge: {
        requestedAgeCluster1: this.inputData.requestedAge ? this.inputData.requestedAge.includes('18-35') : false,
        requestedAgeCluster2: this.inputData.requestedAge ? this.inputData.requestedAge.includes('36-50') : false,
        requestedAgeCluster3: this.inputData.requestedAge ? this.inputData.requestedAge.includes('51+') : false
      },
      requiredLanguage: {
        italian: this.inputData.requiredLanguage ? this.inputData.requiredLanguage.includes('italian') : false,
        english: this.inputData.requiredLanguage ? this.inputData.requiredLanguage.includes('english') : false,
        spanish: this.inputData.requiredLanguage ? this.inputData.requiredLanguage.includes('spanish') : false,
      },
      days: this.colfService.fromStringToAvailObject(this.inputData.workDays, 'days'),
      hours: this.colfService.fromStringToAvailObject(this.inputData.workHours, 'hours')
    });
  }

  private pushDataChanges() {
    const data = this.form.value;

    let requestedAge: string[] = [];
    Object.entries<boolean>(data.requestedAge).forEach((value) => {
      if (value[1]) {
        switch (value[0]) {
          case 'requestedAgeCluster1':
            requestedAge.push('18-35');
            break;

          case 'requestedAgeCluster2':
            requestedAge.push('36-50');
            break;

          case 'requestedAgeCluster3':
            requestedAge.push('51+');
            break;

          default:
            break;
        }
      }
    })

    let requestedExp: string[] = [];
    Object.entries<boolean>(data.requestedExp).forEach((value) => {
      if (value[1]) {
        switch (value[0]) {
          case 'requestedExpCluster1':
            requestedExp.push('Cuccioli');
            break;

          case 'requestedExpCluster2':
            requestedExp.push('Adulti');
            break;

          default:
            break;
        }
      }
    })

    let requiredLanguage: string[] = [];
    Object.entries<boolean>(data.requiredLanguage).forEach((value) => {
      if (value[1]) {
        requiredLanguage.push(value[0]);
      }
    })

    const newColfInfo: ColfRequestDetail = {
      starting: data.starting,
      estimatedLasting: data.estimatedLasting,
      serviceStart: data.serviceStart,
      serviceDuration: data.serviceDuration,
      continuousJob: data.continuousJob,
      moreThanOne: data.moreThanOne,
      badWorkHours: data.badWorkHours,
      taxisitter: data.taxisitter,
      hoursAmount: data.hoursAmount,
      netHourCost: data.netHourCost,
      flatCost: data.flatCost,
      flatCostTiming: +data.flatCostTiming,
      withholdingTax: data.withholdingTax,
      inconvenientLocation: data.inconvenientLocation,
      requestDescription: data.requestDescription,
      requestedAge,
      requestedExp,
      workHours: this.colfService.fromAvailObjectToString(data.hours, 'hours'),
      workDays: this.colfService.fromAvailObjectToString(data.days, 'days'),
      car: data.car,
      license: data.license,
      requestID: this.requestID,
      cooking: data.cooking,
      gardening: data.gardening,
      groceries: data.groceries,
      helping: data.helping,
      houseCleaning: data.houseCleaning,
      ironing: data.ironing,
      sewing: data.sewing,
      terraceCleaning: data.terraceCleaning,
      washingMachines: data.washingMachines,
      windowCleaning: data.windowCleaning,
      requiredLanguage,
      packageFlatCost: data.packageFlatCost,
      coliving: data.coliving,
      relocation: data.relocation,
    }
    this.dataUpdated.emit(newColfInfo);
  }

  updatePricing(pricing:any){
    this.form.setValue({
      ...this.form.value,
      taxisitter: pricing.taxisitter,
      hoursAmount: pricing.hoursAmount,
      netHourCost: pricing.netHourCost,
      flatCost: pricing.flatCost,
      flatCostTiming: pricing.flatCostTiming,
      packageFlatCost: pricing.packageFlatCost,
      withholdingTax: pricing.withholdingTax,
    })
  }
}
